import { render } from "./GroupPromoCodesTab.vue?vue&type=template&id=65cc851c&scoped=true"
import script from "./GroupPromoCodesTab.vue?vue&type=script&lang=js"
export * from "./GroupPromoCodesTab.vue?vue&type=script&lang=js"

import "./GroupPromoCodesTab.vue?vue&type=style&index=0&id=65cc851c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65cc851c"]])

export default __exports__